(function () {
  'use strict';

  var instances = new WeakMap();

  function initPrivacy(root) {
    if (!root || instances.has(root)) return;

    var links = Array.from(root.querySelectorAll('[data-rdv7-pp-toc-link]'));
    if (!links.length) return;

    var sections = links
      .map(function (link) {
        return document.getElementById(link.getAttribute('data-toc'));
      })
      .filter(Boolean);

    function setActive(id) {
      links.forEach(function (link) {
        var active = link.getAttribute('data-toc') === id;
        link.classList.toggle('is-active', active);
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        var visible = entries
          .filter(function (entry) {
            return entry.isIntersecting;
          })
          .sort(function (a, b) {
            return a.boundingClientRect.top - b.boundingClientRect.top;
          });
        if (visible.length) setActive(visible[0].target.id);
      },
      { rootMargin: '-15% 0px -70% 0px', threshold: 0 }
    );

    sections.forEach(function (section) {
      observer.observe(section);
    });

    if (sections[0]) setActive(sections[0].id);

    instances.set(root, {
      disconnect: function () {
        observer.disconnect();
      },
    });
  }

  function destroyPrivacy(root) {
    var instance = instances.get(root);
    if (!instance) return;
    instance.disconnect();
    instances.delete(root);
  }

  function initAll() {
    document.querySelectorAll('[data-rdv7-privacy]').forEach(initPrivacy);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-rdv7-privacy]');
    if (root) initPrivacy(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.querySelector('[data-rdv7-privacy]');
    if (root) destroyPrivacy(root);
  });
})();
